<template>
  <div
    v-if="isImpersonation"
    class="impersonation-banner"
    :class="{ 'impersonation-banner--inline': inline }"
    role="region"
    aria-label="Banner sesi impersonation"
  >
    <div class="impersonation-banner__inner">
      <div class="impersonation-banner__copy">
        <div class="impersonation-banner__title">
          <i class="fa fa-user-secret" aria-hidden="true"></i>
          <span>Anda sedang mengakses akun member melalui Admin Zeus.</span>
        </div>
        <div class="impersonation-banner__desc">
          Anda saat ini mengakses dashboard sebagai administrator.
          <span v-if="memberName">
            Member: <strong>{{ memberName }}</strong>.
          </span>
        </div>
        <div
          v-if="errorMessage"
          class="impersonation-banner__error"
          role="alert"
        >
          {{ errorMessage }}
        </div>
      </div>
      <div class="impersonation-banner__actions">
        <button
          type="button"
          class="btn btn-warning btn-sm"
          :disabled="processing"
          @click="backToZeus"
        >
          <span v-if="processing">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Mengakhiri...
          </span>
          <span v-else>
            <i class="fa fa-arrow-left" aria-hidden="true"></i> Kembali ke ZEUS
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImpersonationBanner",
  props: {
    // Dipakai pada layout yang tidak memiliki navbar fixed 60px
    // (mis. halaman pemilihan lisensi).
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processing: false,
      errorMessage: ""
    };
  },
  computed: {
    isImpersonation() {
      if (this.$store.state.login.isImpersonation !== true) {
        return false;
      }
      // Banner hanya untuk halaman dashboard, bukan handoff/login.
      const path = this.$route && this.$route.path ? this.$route.path : "";
      if (path === "/auth/handoff" || path.indexOf("/login") === 0) {
        return false;
      }
      // Jika profil backend sudah dimuat dan menyatakan bukan impersonation,
      // jangan tampilkan banner (mis. sisa key lama di browser).
      const session = this.memberSession;
      if (session && session.is_impersonation === false) {
        return false;
      }
      return true;
    },
    memberSession() {
      return this.$store.state.login.memberSession;
    },
    memberName() {
      return this.memberSession && this.memberSession.name
        ? this.memberSession.name
        : "";
    }
  },
  methods: {
    async backToZeus() {
      if (this.processing) {
        return;
      }

      const zeusUrl = process.env.VUE_APP_ZEUS_URL;
      if (!zeusUrl) {
        this.errorMessage =
          "Konfigurasi VUE_APP_ZEUS_URL tidak tersedia. Hubungi administrator.";
        return;
      }

      this.processing = true;
      this.errorMessage = "";

      try {
        // Revoke token impersonation di server sebelum sesi lokal dibersihkan.
        // Jika gagal (mis. jaringan), sesi lokal tetap dibersihkan agar admin
        // tidak terjebak; token tidak lagi tersimpan di browser ini.
        await this.$store.dispatch("member/endImpersonation");
      } catch (error) {
        // Best effort: lanjutkan pembersihan sesi lokal.
      }

      // Hanya membersihkan key impersonation; sesi member normal dan sesi
      // admin ZEUS tidak disentuh.
      this.$store.dispatch("login/endImpersonationLocal");
      window.location.href = zeusUrl;
    }
  }
};
</script>

<style>
/* Banner berada di dalam <header> layout utama. Offset 60px menempatkannya
   tepat di bawah navbar fixed 60px; karena memakai position: relative, banner
   tetap berada di alur normal dan tidak menutupi konten. .page-wrapper tetap
   memiliki padding-top 60px untuk navbar, sehingga konten mulai tepat setelah
   banner. */
.impersonation-banner {
  position: relative;
  top: 60px;
  z-index: 1001;
  margin-left: 230px;
  background: #1f2937;
  color: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);
}

.impersonation-banner__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
}

.impersonation-banner__copy {
  min-width: 0;
  flex: 1 1 auto;
}

.impersonation-banner__title {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.impersonation-banner__title .fa {
  color: #fbbf24;
  flex: 0 0 auto;
  margin-top: 2px;
}

.impersonation-banner__desc {
  margin-top: 2px;
  color: #d1d5db;
  font-size: 0.8125rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.impersonation-banner__desc strong {
  color: #fff;
  font-weight: 600;
}

.impersonation-banner__error {
  margin-top: 4px;
  color: #fca5a5;
  font-size: 0.8125rem;
}

.impersonation-banner__actions {
  flex: 0 0 auto;
}

/* Sidebar mini (60px) */
body.mini-sidebar .impersonation-banner {
  margin-left: 60px;
}

/* Layout tanpa navbar fixed (mis. pemilihan lisensi): banner ikut alur normal */
.impersonation-banner--inline {
  top: 0;
  margin-left: 0;
}

body.mini-sidebar .impersonation-banner--inline {
  margin-left: 0;
}

/* Mobile: sidebar off-canvas, informasi vertikal, tombol full-width */
@media (max-width: 767.98px) {
  .impersonation-banner {
    margin-left: 0;
  }

  .impersonation-banner__inner {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px 15px;
  }

  .impersonation-banner__actions {
    width: 100%;
  }

  .impersonation-banner__actions .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ImpersonationBanner.vue